import React, {useEffect} from "react";
import CloneRepo from "./CloneRepo.jsx";
import Overview from "./Overview.jsx";
import { useDispatch, useSelector } from "react-redux";
import { resetCodeOverview } from "../../state/reducers/codeOverview.js";

function CodeOverview() {
  const showOverview = useSelector((state) => state.codeOverview.showOverview)
  const dispatch = useDispatch()

  useEffect(() => {
    return(() => {
      dispatch(resetCodeOverview())
    })
  }, [])

  return (
    <>
      {!showOverview && <CloneRepo />}
      {showOverview && <Overview />}
    </>
  );
}

export default CodeOverview;